var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { on: { click: _vm.openDialog } },
        [
          _c("el-button", { attrs: { icon: _vm.icon, type: _vm.type } }, [
            _vm._v("表单记忆设置 "),
          ]),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "Weforsys-dialog Weforsys-dialog_center",
          attrs: {
            title: _vm.titletext,
            "close-on-click-modal": false,
            visible: _vm.visible,
            "lock-scroll": "",
            width: "800px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "Weforsys-table",
                {
                  ref: _vm.reftext,
                  staticClass: "liststyle",
                  attrs: {
                    data: _vm.lists,
                    "highlight-current-row": "",
                    hasNO: false,
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "Columns",
                      label: "列名",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "Width",
                      label: "列表宽度",
                      align: "center",
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              attrs: { placeholder: "", type: "number" },
                              model: {
                                value: scope.row.Width,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "Width", $$v)
                                },
                                expression: "scope.row.Width",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      type: "index",
                      width: "100",
                      label: "排序号",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "TransportCode",
                      label: "操作",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.moveUp(scope.$index, _vm.lists)
                                  },
                                },
                              },
                              [_vm._v("上移")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.moveDown(scope.$index, _vm.lists)
                                  },
                                },
                              },
                              [_vm._v("下移")]
                            ),
                            _c("el-input", {
                              staticClass: "elinputclass",
                              attrs: { placeholder: "", type: "number" },
                              model: {
                                value: scope.row.number,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "number", $$v)
                                },
                                expression: "scope.row.number",
                              },
                            }),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.directaccess(
                                      scope.row,
                                      scope.$index
                                    )
                                  },
                                },
                              },
                              [_vm._v("直达")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.resetform()
                    },
                  },
                },
                [_vm._v("重置表单")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("common.cancelButton")) +
                      "\n      "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.loadingbut,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.select()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.confirmButton")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }